export const termsAndConditionsLinks = {
  hy: "https://ameriabank.am/Portals/0/files/Business/Terms_and_conditions_lp.pdf",
  en: "https://ameriabank.am/Portals/0/files/Business/Terms_and_conditions_lp_eng.pdf",
  ru: "https://ameriabank.am/Portals/0/files/Business/Terms_and_conditions_lp_rus.pdf",
};

export const MAX_FILE_SIZE = 5 * 1024 * 1024;
export const SUPPORTED_DOCUMENT_FILE_TYPES = [
  "image/jpeg",
  "image/jpg",
  "image/png",
  "application/pdf",
  ".jpeg",
  ".jpg",
  ".png",
  ".pdf",
];
